import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) { console.error("BARIQUE UI error:", error, info); }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, fontFamily: "Arial, sans-serif", textAlign: "center", background: "#f8f7f3", color: "#111" }}>
        <div>
          <h1 style={{ fontWeight: 400, letterSpacing: "0.08em" }}>BARIQUE</h1>
          <p>We could not load this page correctly.</p>
          <button onClick={() => window.location.reload()} style={{ padding: "12px 20px", background: "#111", color: "#fff", border: 0, cursor: "pointer" }}>Reload website</button>
        </div>
      </div>
    );
  }
}
